import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import API_URL from '../config/api';

// Configuración global de axios (AGREGAR ESTO)
axios.defaults.withCredentials = true;
axios.defaults.headers.common['Content-Type'] = 'application/json';

const AuthContext = createContext(null);

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth debe usarse dentro de AuthProvider');
  }
  return context;
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      fetchUser(token);
    } else {
      setLoading(false);
    }
  }, []);

  async function fetchUser(token) {
    try {
      const response = await axios.get(`${API_URL}/api/auth/profile`, {
        headers: { Authorization: `Bearer ${token}` },
        withCredentials: true // 👈 AGREGADO EXPLÍCITAMENTE
      });
      setUser(response.data.data);
    } catch (error) {
      console.error('Error fetching user:', error);
      localStorage.removeItem('token');
    } finally {
      setLoading(false);
    }
  }

  async function login(email, password) {
    try {
      const response = await axios.post(`${API_URL}/api/auth/login`, 
        { email, password },
        { withCredentials: true } // 👈 AGREGADO
      );
      
      const userData = response.data.data;
      localStorage.setItem('token', userData.token);
      setUser(userData);
      toast.success(`¡Bienvenido ${userData.name}!`);
      return true;
    } catch (error) {
      toast.error(error.response?.data?.message || 'Error al iniciar sesión');
      return false;
    }
  }

  function logout() {
    localStorage.removeItem('token');
    setUser(null);
    toast.success('Sesión cerrada');
  }

  const isOwner = user?.role === 'owner';
  const isAdmin = user?.role === 'admin';
  const adminType = isAdmin ? (user?.adminId === 1 ? 'Principal' : 'Secundario') : null;
  
  const canDeleteClients = isOwner || user?.permissions?.canDeleteClients;
  const canExportData = isOwner || user?.permissions?.canExportData;
  const canManageUsers = isOwner;
  const canCreateClients = isOwner || user?.permissions?.canCreateClients;
  const canProcessPayments = isOwner || user?.permissions?.canProcessPayments;

  const value = {
    user,
    loading,
    login,
    logout,
    isOwner,
    isAdmin,
    adminType,
    canDeleteClients,
    canExportData,
    canManageUsers,
    canCreateClients,
    canProcessPayments,
    maxAdmins: 2,
    currentAdmins: 0
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}